<div nz-col nzSpan="24">
	<div class="inner-box">
		<div nz-row>
			<div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="inner-box-container">
				<div nz-row [nzGutter]="{xs: 8, sm: 8, md: 8, lg: 24, xl: 48, xxl: 48}">
					<div nz-col nzMd="12" nzSm="24">
						<div class="inner-box">
							<form nz-form (ngSubmit)="generateTrasactionHistory()" class="search__form">
								<div nz-row [nzGutter]="{xs: 24, sm: 24, md: 8, lg: 4, xl: 8, xxl: 48}">
									<div nz-col nzMd="13" nzXs="24" nzSm="24">
										<nz-form-item>
											<nz-form-control>
												<nz-range-picker nz-tooltip
													nzTooltipTitle="{{'BILLING.TRANSACTION-HISTORY.DATE_TOOLTIP' | translate}}"
													nzTooltipPlacement="bottom" [nzTooltipColor]="'#000148'" [nzRanges]="ranges"
													[nzPlaceHolder]="['GENERAL.START_DATE' | translate, 'GENERAL.END_DATE' | translate]"
													[(ngModel)]="searchParams.range" name="range" id="updatedAt" (ngModelChange)="
														onDateChange($event); filterOnChange()
													"></nz-range-picker>
											</nz-form-control>
										</nz-form-item>
									</div>
									<div nz-col nzMd="11" nzXs="24" nzSm="24">
										<button class="card-btn-fundng" nz-button type="submit" [nzType]="'primary'"
											[nzLoading]="isGenerating" [disabled]="isGenerating">
											<span>{{'GENERAL.SEARCH' | translate}}</span>
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
					<div nz-col nzMd="10" nzSm="24" class="ml-auto">
						<div class="mt-30 float-right">
							<button class="card-btn-funding" nz-button [nzType]="'primary'" (click)="displayServiceCharge()">
								<span>{{'GENERAL.VIEW_SERVICE_CHARGE' | translate}}</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<div nz-col class="table-box" nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
				<nz-table [nzLoading]="loading" #nzTable [nzShowPagination]="false" [nzBordered]="false"
					[nzData]="transactionDetails" [nzFooter]="pagination" [nzShowTotal]="showTotal()">
					<ng-template #pagination>
						<div class="text-right pagination-wrapper">
							<nz-pagination [nzPageIndex]="current_page" [nzTotal]="total" [nzItemRender]="renderItemTemplate"
								[nzShowTotal]="rangeTemplate"></nz-pagination>
							<ng-template #renderItemTemplate let-type let-page="page">
								<ng-container [ngSwitch]="type">
									<a *ngSwitchCase="'page'" (click)="next(page)">{{ page }}</a>
									<a *ngSwitchCase="'next'" (click)="next(current_page + 1)"><strong *ngIf="nextPage">{{('GENERAL.NEXT'
											| translate) | titlecase}}</strong></a>
									<a *ngSwitchCase="'prev_5'">
										<< </a>
											<a *ngSwitchCase="'next_5'">>></a>
								</ng-container>
							</ng-template>
							<ng-template #rangeTemplate let-total>
								{{ from }}-{{ to }} {{('GENERAL.OF' | translate) | lowercase}} {{ total }} {{ 'GENERAL.ITEMS' |
								translate}}
							</ng-template>

							<button *ngIf="transactionDetails.length" class="card-btn-funding" nz-button [disabled]="isExporting"
								[nzLoading]="isExporting" (click)="exportTrasactionHistory()">
								<span>{{'GENERAL.EXPORT' | translate}}</span>
							</button>
						</div>
					</ng-template>
					<thead>
						<tr>
							<th>{{'BILLING.TRANSACTION-HISTORY.TRANSACTION_TIME' | translate}}</th>
							<th>{{'GENERAL.TRANSACTION_ID' | translate}}</th>
							<th>{{'BILLING.TRANSACTION-HISTORY.ACTIVITY' | translate}}</th>
							<th>{{'GENERAL.UNITS' | translate}}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of nzTable.data">
							<td>
								{{ data?.created_at | date: 'mediumDate' }}
								<br />
								<p>{{ data?.created_at | date: 'mediumTime' }}</p>
							</td>
							<td>{{ data?.id }}</td>
							<td>{{ translateAction(data?.action) | titleCaseNoUnderScore }}</td>
							<td>
								<b [ngStyle]="{
										color: data?.action == 'credit' ? 'green' : 'red'
									}" class="green">
									{{ data?.amount | number }}
								</b>
							</td>
						</tr>
					</tbody>
				</nz-table>
			</div>
		</div>
	</div>
</div>

<!-- SERVICE CHARGE MODAL -->
<nz-modal [nzStyle]="{ top: '20px' }" [nzMask]="true" nzMaskClosable="false" nzWidth="600px" nzClosable="true"
	[(nzVisible)]="viewServiceChargeModal" nzTitle="{{'GENERAL.SERVICE_CHARGE' | translate}}"
	[nzContent]="modalServiceCharge" [nzFooter]="null" (nzOnCancel)="dismissServiceChargeModal()">
	<ng-template #modalServiceCharge>
		<!-- <app-billing
      
    ></app-billing> -->
		<p class="modal-desc">{{ serviceChargeModalText | translate}}</p>

		<div class="service-charge-modal" *ngIf="user.type == userTypes.USER">
			<p class="item-access">
				<b>{{'GENERAL.CERTIFICATE_ACCESS' | translate}}: </b>
				<span>{{ accessCost || 0 }} {{'GENERAL.UNIT' | translate}}<span *ngIf="accessCost > 0">s</span>
					<span *ngIf="currency"> ({{
						isLocalTransaction() ?
						userCountry?.symbol+(accessLocalCost | number) :"&#36;"+(accessCost | number)
						}})</span>
				</span>
			</p>
			<p class="item-access">
				<b>{{'GENERAL.SHARING_FEE' | translate}}: </b>
				<span>{{ sharingCost || 0 }} {{'GENERAL.UNIT' | translate}}<span *ngIf="sharingCost > 0">s</span>
					<span *ngIf="currency"> ({{
						isLocalTransaction() ?
						userCountry?.symbol+ (sharingLocalCost | number) :"&#36;"+ (sharingCost | number)
						}})
					</span>
				</span>
			</p>
			<p class="item-access">
				<b>{{'GENERAL.SERVICE_CHARGE_CONFIRM_INT' | translate}}:</b>
				<span> {{ requestConfirmationCost || 0}} {{'GENERAL.UNIT' | translate}}<span
						*ngIf="requestConfirmationCost > 0">s</span>
					<span *ngIf="currency"> ({{
						isLocalTransaction() ?
						userCountry?.symbol+ (requestConfirmationLocalCost | number):"&#36;"+ (requestConfirmationCost | number)
						}})
					</span>
				</span>
			</p>
			<p class="item-access">
				<b>{{'GENERAL.SERVICE_CHARGE_CONFIRM_LOCAL' | translate}}:</b>
				<span> {{ sharingCost || 0}} {{'GENERAL.UNIT' | translate}}<span *ngIf="sharingCost > 0">s</span>
					<span *ngIf="currency"> ({{
						isLocalTransaction() ?
						userCountry?.symbol+ (sharingLocalCost | number):"&#36;"+ (sharingCost | number)
						}})
					</span>
				</span>
			</p>
			<p class="item-access">
				<b>{{'BILLING.RETRIEVAL_FEE' | translate}}: </b>
				<span>{{retrievalCost || 0}} {{'GENERAL.UNIT' | translate}}<span *ngIf="retrievalCost > 0">s</span>
					<span *ngIf="currency"> ({{
						isLocalTransaction() ?
						userCountry?.symbol+ (retrievalLocalCost | number) :"&#36;"+ (retrievalCost | number)
						}})
					</span>
				</span>
			</p>
		</div>
		<div class="item-container" *ngIf="user.type == userTypes.VERIFIER">
			<p class="item-access mb-15px">
				<b>{{'GENERAL.CONFIRMATION' | translate}}: </b>
				<span>{{ verificationCost || 0 }} {{'GENERAL.UNIT' | translate}}<span *ngIf="verificationCost > 0">s</span>
					<span *ngIf="currency"> ({{
						isLocalTransaction() ?
						userCountry?.symbol+ (verificationLocalCost | number ):"&#36;"+ (verificationCost | number)
						}})
					</span>
				</span>
			</p>
		</div>

		<div nz-row>
			<div class="processor-icons " nz-col nzXs="24" nzMd="24">
				<span class="powered-by">{{'GENERAL.POWERED_BY' | translate}}</span> <img class="icons ml-3"
					src="/assets/icons/payment_processors/flutterwave.svg" alt="">
				<img class="icons paystack ml-3" src="/assets/icons/payment_processors/paystack.svg" alt="">
			</div>
		</div>
	</ng-template>
</nz-modal>